import Route from './Route';

const reportsService = process.env.REACT_APP_URL_REPORTS_SERVICE_ROOT + '/v1/';
const railsEndpoint = process.env.REACT_APP_URL_BACKEND_RAILS;
const docsEndpoint = process.env.REACT_APP_URL_BACKEND_DOCS;
const publicUrl = process.env.PUBLIC_URL;
const tenant = process.env.REACT_APP_TENANT;

export default {
    surveys: new Route(
        railsEndpoint +
            '/explore-tables?tenant=:tenant&preview_datasets_not_included_in_current_subscription=:previewAllDatasets',
    ),
    getDatasets: new Route(
        reportsService +
            'GetDatasets?surveyName=:surveyName&includeTables=:includeTables',
    ),
    getTables: new Route(
        reportsService +
            'GetTables?datasetName=:datasetName&surveyName=:surveyName&bIncludeVariables=:includeVariables',
    ),
    getPremadeReports: new Route(
        reportsService + 'GetSystemReports?surveyName=:surveyCode',
    ),
    getGeoTypes: new Route(
        reportsService +
            'GetGeoTypes?surveyName=:surveyCode&onlyMajorGeographies=:onlyMajorGeographies',
    ),
    getGeoSelectionsCount: new Route(
        reportsService +
            'GetReportGeoSelectionsCount?' +
            'reportId=:oldReportId&' +
            'aggregationType=:aggregationType',
    ),
    getParentGeoTypes: new Route(
        reportsService +
            'GetParentGeoTypes?geoTypeName=:geoTypeName&surveyName=:surveyCode',
    ),
    getGeoItemsByGeoType: new Route(
        reportsService +
            'GetGeoItemsByGeoType?' +
            'geoTypeSelectionName=:geoTypeSelectionName&' +
            'geoSelectionFips=:geoSelectionFips&' +
            'surveyName=:surveyName',
    ),
    getGeoItemsByFipsCodes: new Route(
        reportsService +
            'GetGeoItemsByFipsCodes?' +
            'onlyMajorGeographies=:onlyMajorGeographies&' +
            'fipsCodes=:fipsCodes&' +
            'requestedGeoType=:requestedGeoType&' +
            'surveyName=:surveyName',
    ),
    createReport: new Route(railsEndpoint + '/report/create'),
    getReportInfo: new Route(
        reportsService + 'GetHtmlReportByReportId?reportId=:oldReportId',
    ),
    getTablesByReportId: new Route(
        reportsService +
            'GetTablesByReportId?' +
            'reportId=:oldReportId&' +
            'includeVariables=:includeVariables',
    ),
    getReportMetadata: new Route(
        railsEndpoint + '/report/:reportId/metadata?tenant=' + tenant,
    ),
    getReportMetadataV2: new Route(
        railsEndpoint + '/report/:reportId/metadata-v2?tenant=' + tenant,
    ),
    getConsumerPriceIndices: new Route(
        reportsService + 'GetConsumerPriceIndices',
    ),
    getFipsCodesOfReport: new Route(
        reportsService +
            'GetFipsCodesOfReport2?reportId=:oldReportId&aggregationType=:aggregationType',
    ),
    allowDollarAdjustment: new Route(
        reportsService + 'AllowDollarAdjustment?reportId=:oldReportId',
    ),
    saveReport: new Route(railsEndpoint + '/report/save_report'),
    deleteReport: new Route(railsEndpoint + '/report/delete_report'),
    updateReport: new Route(railsEndpoint + '/report/update_report'),
    duplicateReport: new Route(railsEndpoint + '/report/duplicate_report'),
    licensesUrl: new Route(railsEndpoint + '/licenses'),
    helpUrl: new Route(railsEndpoint + '/help'),
    railsSessionUrl: new Route(railsEndpoint + '/session'),
    sessionInfo: new Route(railsEndpoint + '/session-info'),
    reportUrl: new Route(publicUrl + '/report/:reportId'),
    documentationUrl: new Route(
        railsEndpoint + '/data/:surveyCode/documentation/',
    ),
    dataDictionaryUrl: new Route(railsEndpoint + '/data/:surveyCode'),
    createDownloadExcelUrlRequestUrl: new Route(
        reportsService +
            'GetExcelFileDownloadLink?' +
            'surveyName=":surveyCode"&' +
            'sReportId=":reportId"&' +
            'sReportType=":reportType"&' +
            'percents=":percents"&' +
            'aggregatesOnly=":aggregatesOnly"&' +
            'outputChange=":outputChange"&' +
            'wrapVarLabels=":wrapVarLabels"&' +
            'freezeGeoRowAndVarCol=":freezeGeoRowAndVarCol"&' +
            'varHighlightPercentAndAgg=":varHighlightPercentAndAgg"&' +
            'marginsToHalfIn=":marginsToHalfIn"&' +
            'printZoomTo75=":printZoomTo75"&' +
            'varLablesGeoNamesOnEachPage=":varLablesGeoNamesOnEachPage"',
    ),
    csvDownload: new Route(
        reportsService + 'DownloadCsvFile?ReportId=:reportId',
    ),
    getGeoTypeSelections: new Route(
        reportsService + 'GetGeoTypeSelections?reportId=:oldReportId',
    ),
    getDataSlicedByGeoItemsRange: new Route(
        reportsService +
            'GetDataForReport2' +
            '?reportId=:oldReportId' +
            '&geoItemStartIndex=:geoItemStartIndex' +
            '&geoItemSlice=:geoItemSlice' +
            '&aggregationType=:aggregationType' +
            '&adjustDollarValuesToYear=:adjustDollarValuesToYear' +
            '&tableGuids=:tableGuids',
    ),
    getTablesByGuids: new Route(reportsService + 'GetTablesByGuids'),
    template: new Route(railsEndpoint + '/report-tables-template'),
    getTableTemplateById: new Route(
        railsEndpoint + '/report-tables-template/:id',
    ),
    updateTableTemplateById: new Route(
        railsEndpoint + '/report-tables-template/update/:id',
    ),
    metadataLink: new Route(
        docsEndpoint +
            '/data/:surveyCode/metadata?' +
            'ds=:datasetAbbreviation' +
            '&table=:name',
    ),
    counterEvent: new Route(railsEndpoint + '/counter/event'),

    dashboardUrl: new Route(railsEndpoint + '/selfstorage/dashboard'),
    myTemplates: new Route(railsEndpoint + '/selfstorage/dashboard'),
    exploreMaps: new Route(railsEndpoint + '/selfstorage/dashboard'),
    paidPlan: new Route(
        'mailto:upgrade@tractiq.com?subject=Trial - Subscription inquiry',
    ),
    loginUrl: new Route(railsEndpoint + '/selfstorage/login'),
    signUpUrl: new Route(railsEndpoint + '/selfstorage/contact'),
};
